<div class="flex gap-4">
	<p
		*ngIf="allowCancel"
		class="hover:underline cursor-pointer"
		(click)="cancel()"
		[testHook]="testHooks.CancelParagraph"
	>
		Cancel order
	</p>
	<p class="text-green underline cursor-pointer">
		<a
			externalNavInterceptor
			href="http://www.stewart.ca/quote"
			target="_blank"
			[testHook]="testHooks.GetQuoteLink"
			>Get quote</a
		>
	</p>
</div>
